<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver2">
    <Error_messages :error_message="messages.error" :success_message = "messages.success"/>  
    <form @submit.prevent="handleSubmit(validateEmail)" ref="form2">
        <ValidationProvider vid="code" name="Code" :rules="rules.code" v-slot="{ errors }">
         <div class="form-group">
          <VuePincodeInput
          v-model="validateEmailForm.code"
          :length="6"
          type="numeric"
          focus
          />
        </div>
        </ValidationProvider>
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
      <button v-else type="submit" class="btn btn-primary float-right">Validate Code</button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import {validateEmail} from "@/API/UsersAPIs";
import VuePincodeInput from "vue-pincode-input";
import Error_messages from "@/helpers/error_messages.vue";
export default {
  props: ['email', 'phone'],
  components: {
    VuePincodeInput,
    Error_messages
  },
  data() {
    return {
      loading: false,
      messages: { error: "", success: "" },
      validateEmailForm: {
        phone: '',
        email: '',
        code: ''
      },
      rules: {
        email: 'required|email',
        code: 'required|length:6',
        phone: 'required',
      },
    }
  },
  methods: {
    async validateEmail() {
      this.loading = true;
        try {
           await validateEmail(this.validateEmailForm)
          this.$emit('setStep', 3)
          this.$emit('setCode',  this.validateEmailForm.code);
          this.messages.error="";
          this.loading = false;
        }catch(error) {
          console.log(error.response.data.errors.phone_required[0]);
          this.messages.error = error.message === "Network Error" 
          ? error.message 
          : error.response.data.errors.phone_required[0];
          }finally{ this.loading = false}
    },
    stopLoading(loader){
      loader.hide();
      this.loading = false;
    },
  },
  mounted() {
    if(this.phone){
      this.validateEmailForm ={phone:this.phone, code:''};
    }else{
      this.validateEmailForm ={email:this.email, code:''};
    }
  },
}
</script>

<style scoped>

</style>
